import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("e5b0d38112", ".fef3d1a330db4b0f__container{height:100%}");
}
export default {"container":"fef3d1a330db4b0f__container"};
